import TaxiCorporationUnbilledRouteListRequest, {
  TaxiCorporationUnbilledRouteListRequestOrder,
} from "../../../../api/raily/taxi-corporation/unbilled/route-list/taxi-corporation-unbilled-route-list.request";
import TaxiCorporationUnbilledRouteListParams, {
  TaxiCorporationUnbilledRouteListParamsOrder,
} from "./taxi-corporation-unbilled-route-list-params";

const createOrder = (
  order: TaxiCorporationUnbilledRouteListParamsOrder | undefined,
): TaxiCorporationUnbilledRouteListRequestOrder | undefined => {
  switch (order) {
    case TaxiCorporationUnbilledRouteListParamsOrder.DRIVER_ASC:
      return TaxiCorporationUnbilledRouteListRequestOrder.DRIVER_ASC;
    case TaxiCorporationUnbilledRouteListParamsOrder.DRIVER_DESC:
      return TaxiCorporationUnbilledRouteListRequestOrder.DRIVER_DESC;
    case TaxiCorporationUnbilledRouteListParamsOrder.HUMAN_ID_ASC:
      return TaxiCorporationUnbilledRouteListRequestOrder.HUMAN_ID_ASC;
    case TaxiCorporationUnbilledRouteListParamsOrder.HUMAN_ID_DESC:
      return TaxiCorporationUnbilledRouteListRequestOrder.HUMAN_ID_DESC;
    case TaxiCorporationUnbilledRouteListParamsOrder.START_TIME_ASC:
      return TaxiCorporationUnbilledRouteListRequestOrder.START_TIME_ASC;
    case TaxiCorporationUnbilledRouteListParamsOrder.START_TIME_DESC:
      return TaxiCorporationUnbilledRouteListRequestOrder.START_TIME_DESC;
    default:
      return undefined;
  }
};

const createRequest = (
  params: TaxiCorporationUnbilledRouteListParams,
): TaxiCorporationUnbilledRouteListRequest => {
  return {
    address: params.address,
    cargoOrderHumanId: params.cargoOrderHumanId,
    client: params.client,
    driver: params.driver,
    endAddress: params.endAddress,
    externalId: params.externalId,
    fleetPartner: params.fleetPartner,
    humanId: params.humanId,
    limit: params.limit,
    midAddress: params.midAddress,
    offset: params.offset,
    order: createOrder(params.order),
    startAddress: params.startAddress,
    startTimeSince: params.startTimeSince,
    startTimeTo: params.startTimeTo,
    taxiCorporationUuid: params.taxiCorporationUuid,
  };
};

const taxiCorporationUnbilledRouteListParamsFactory = {
  createRequest,
};

export default taxiCorporationUnbilledRouteListParamsFactory;
